export enum TrialAccountRequestStatus {
  New = 'new',
  Approved = 'approved',
  Declined = 'declined',
}

export interface TrialAccountRequest {
  readonly id: string;
  readonly status: TrialAccountRequestStatus;
  readonly firstName: string;
  readonly lastName: string;
  readonly email: string;
  readonly phoneNumber: string;
  readonly companyName: string;
  readonly jobTitle: string;
  readonly requestedAt: string;
  readonly metadata: {
    readonly ipAddress: string;
    readonly refereUrl: string;
    readonly utmSource: string;
    readonly utmCampaign: string;
    readonly utmMedium: string;
    readonly utmTerm: string;
    readonly adwGclid: string;
  };
  readonly accountId?: string;
  readonly declinedAt?: string;
  readonly approvedAt?: string;
}
